<template>
    <div v-if="ready" class="pc-link-wrapper">
    <button class="button m-1 flat-button" @contextmenu.prevent.stop="openContextMenu">

        <router-link class="flat-button p-0 m-0" style="min-width: unset;" :to="(editURL ? '#openpc:' : '/computers/computer/') + pc.id">
            <div v-if="toBool(seeConnectionStatus) || toBool(seeHealth)" class="d-flex flex-align-center h-100">
                <IperiusONEIcon v-if="toBool(seeConnectionStatus)" :pc="pc" :hint-position="hintPosition" />

                <div v-if="seeHealth" class="d-flex align-items-center ml-1">
                    <span data-role="hint" :data-hint-position="hintPosition" :data-hint-text="pc.healthMessage" class="mif-heartbeat mif-2x ml-2" :class="pc.healthColor" style="font-size:20px; line-height:1;"></span>
                    <!--<span :title="healthMessage" class="mif-heartbeat mif-2x ml-2" :class="pc.healthColor" style="font-size:20px; line-height:1;"></span>-->
                </div>
            </div>
            <!--div class="col d-flex flex-align-start flex-column">
                <span class="ml-1 text-bold" data-role="hint" :data-hint-text="pc.pc_name">{{ ellipsis(pc.pc_name,ellipsisLen) }}</span>
                <span v-if="![undefined, null, '', pc.pc_name].includes(pc.name)" class="badge inline bg-transparent ml-0 p-0 pl-1 text-truncate" style="display:block; width:100%;">{{ ellipsis(pc.name, ellipsisLen) }}</span>
                <span v-if="![undefined, null, '', pc.pc_name, pc.name].includes(pc.description)" class="badge inline bg-transparent ml-0 p-0 pl-1 text-truncate" style="display:block; width:100%;">{{ ellipsis(pc.description, ellipsisLen) }}</span>
            </div-->
            <span v-if="seeName" class="ml-1 text-bold" data-role="hint" :data-hint-position="hintPosition" :data-hint-text="[
                pc.pc_name
                    ? (
                        (!pc.name && !pc.description)
                            ? $t('Custom name') + ': ' + pc.pc_name   // caso: SOLO pc.pc_name
                            : $t('Computer name') + ': ' + pc.pc_name // caso: ci sono anche altri campi
                    )
                    : null,
                pc.name
                    ? $t('Custom name') + ': ' + pc.name
                    : null,
                pc.description
                    ? $t('Description') + ': ' + pc.description
                    : null
            ].filter(Boolean).join('<br>')">
                {{ ellipsis(pc.name ? pc.name : pc.pc_name, ellipsisLen) }}
            </span>




        </router-link>
    </button>

    <div v-if="contextMenu.visible" class="pc-link-context-menu" :style="contextMenuStyle" role="menu" @click.stop>
        <button type="button" role="menuitem" @click="openInNewTab">{{ $t("Open in another tab") }}</button>
        <button type="button" role="menuitem" @click="openInNewWindow">{{ $t("Open in another window") }}</button>
    </div>
    </div>

</template>
<script>
import IperiusONEIcon from './IperiusONEIcon.vue';


export default {
    name: "PCLink",
    components: {
        IperiusONEIcon
    },
    props: {
        pc: {
            type: Object,
            required: true
        },
        editURL: Boolean,
        seeHealth: Boolean,
        seeConnectionStatus: Boolean,
        hintPosition: {
            type: String,
            default: "top"
        },
        seeName: {
            type: Boolean,
            default: true
        }

    },
    data() {
        return {
            ready: false,
            ellipsisLen: 30, // lunghezza max visualizzata
            iconHeight: 0,
            contextMenu: {
                visible: false,
                x: 0,
                y: 0
            }
        }
    },
    computed: {
        pcRoute() {
            return {
                name: 'Computer',
                params: { idPC: this.pc.id }
            };
        },
        contextMenuStyle() {
            return {
                left: `${this.contextMenu.x}px`,
                top: `${this.contextMenu.y}px`
            };
        }
    },
    methods: {
        ellipsis(str, max) {
            if (!str) return '';
            const s = String(str);
            return s.length > max ? s.slice(0, max - 1) + '…' : s;
        },
        toBool(v) {
            if (v === 'true') return true;
            if (v === 'false') return false;
            return !!v;
        },
        openContextMenu(event) {
            document.dispatchEvent(new Event('click'));

            const menuWidth = 240;
            const menuHeight = 82;
            this.contextMenu.x = Math.max(8, Math.min(event.clientX, window.innerWidth - menuWidth - 8));
            this.contextMenu.y = Math.max(8, Math.min(event.clientY, window.innerHeight - menuHeight - 8));
            this.contextMenu.visible = true;

            document.addEventListener('click', this.closeContextMenu);
            document.addEventListener('keydown', this.onContextMenuKeydown);
            window.addEventListener('scroll', this.closeContextMenu, true);
            window.addEventListener('resize', this.closeContextMenu);
        },
        closeContextMenu() {
            this.contextMenu.visible = false;
            document.removeEventListener('click', this.closeContextMenu);
            document.removeEventListener('keydown', this.onContextMenuKeydown);
            window.removeEventListener('scroll', this.closeContextMenu, true);
            window.removeEventListener('resize', this.closeContextMenu);
        },
        onContextMenuKeydown(event) {
            if (event.key === 'Escape') this.closeContextMenu();
        },
        resolvedPCUrl() {
            // In produzione una nuova scheda richiede l'URL direttamente al web server.
            // Con il router in history mode, il server potrebbe non avere il fallback
            // per /computers/computer/:idPC. Entriamo quindi dalla root dell'app e
            // lasciamo che Vue Router completi la navigazione lato client.
            const route = this.$router.resolve({
                name: 'login',
                query: { openPC: this.pc.id }
            });
            return new URL(route.href, window.location.href).href;
        },
        openInNewTab() {
            window.open(this.resolvedPCUrl(), '_blank', 'noopener,noreferrer');
            this.closeContextMenu();
        },
        openInNewWindow() {
            const windowName = `pc-${this.pc.id}-${Date.now()}`;
            window.open(this.resolvedPCUrl(), windowName, 'noopener,noreferrer,width=1200,height=800');
            this.closeContextMenu();
        }
    },
    mounted() {
        if (this.toBool(this.seeConnectionStatus)) {
            this.iconHeight = [2, 3].includes(this.pc.backup_license_status) ? 25 : 20;
        }

        if (this.toBool(this.seeHealth) && this.pc.healthMessageParts != null && this.pc.healthMessageParts.length!=0) {
            this.pc.healthMessage = this.pc.healthMessageParts.map(m => this.$t(m)).join('<br/>');
        }
        this.ready=true;
    },
    beforeDestroy() {
        this.closeContextMenu();
    }
}
</script>

<style scoped>
.pc-link-wrapper {
    display: inline-block;
}

.pc-link-context-menu {
    position: fixed;
    z-index: 30000;
    display: flex;
    flex-direction: column;
    width: 232px;
    padding: 4px 0;
    background: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    box-shadow: 0 5px 16px rgba(0, 0, 0, .2);
}

.pc-link-context-menu button {
    width: 100%;
    padding: 9px 14px;
    background: transparent;
    border: 0;
    color: #1d1d1d;
    text-align: left;
    cursor: pointer;
}

.pc-link-context-menu button:hover,
.pc-link-context-menu button:focus {
    background: #f1f3f5;
    outline: none;
}
</style>
